export default __webpack_public_path__ + "static/banner-media-release-oct16-a304e4b2f6e9108c7767e19fb90cb7d9.jpg";